import { Component } from '@angular/core';
import { RemediationModalComponent } from '../remediation-modal/remediation-modal.component';
import { TEACHER_ROUTE } from 'app/teacher/routing-constants/teacher-routing.constant';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { MinistryFeedbackService } from 'app/core/ministry-feedback/ministry-feedback.service';
import { ModalService } from 'app/core/modals/services/modal.service';
import { TeacherService } from 'app/teacher/services/teacher.service';
import { AuthenticationService } from 'app/core/authentication';

@Component({
    selector: 'kh-teacher-remediation-modal',
    templateUrl: './teacher-remediation-modal.component.html',
    styleUrls: ['./teacher-remediation-modal.component.less'],
    standalone: false
})
export class TeacherRemediationModalComponent extends RemediationModalComponent{
  public classId = this.activatedRoute.snapshot.paramMap.get('classId') as string;

  public constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly router: Router,
    bsModalRef: BsModalRef,
    feedbackService: MinistryFeedbackService,
    modalService: ModalService,
    teacherService: TeacherService,
    authService: AuthenticationService
  ) {
    super(teacherService, feedbackService, modalService, bsModalRef, authService);
  }
  
  public goToTeacherStudentGapDetail(logicalErrorId: string): void {
    const route = TEACHER_ROUTE.REMEDIATION.route(this.classInfo.ClassId, logicalErrorId);
    this.router.navigate(route);
    this.closeModal();
   }
}
